/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import axios from 'axios';

/**
 * Helper function for axios requests, mainly to aid in extracting errors properly.
 */
export const handleAxiosRequest = async requestPromise => {
  try {
    const response = await requestPromise;
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error.message);
    }
    throw error;
  }
};